<template>
  <div>
    <Modal importStyle="App">
      <template #default>
        <div :class="`${classVariableName}-gallery-details-container`">
          <div :class="`${classVariableName}-gallery-details-modal-header`">
            <div
              :class="`${classVariableName}-gallery-details-modal-header-back`"
              v-if="detailedGalleryFlow"
              @click="openDetailedGallery"
            >
              <Arrow :direction="'left'" /> Back
            </div>
            <svg
              :class="`${classVariableName}-cursor-pointer ${classVariableName}-auto-margin-left`"
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="onClose"
            >
              <circle cx="14.5" cy="14.5" r="14.5" fill="#F4F4F4" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.6332 17.102C16.9259 17.3947 17.4016 17.3942 17.6949 17.1009C17.9883 16.8075 17.9887 16.3318 17.696 16.0391L15.6352 13.9783L17.7021 11.9114C17.9954 11.6181 17.9959 11.1424 17.7032 10.8496C17.4105 10.5569 16.9348 10.5574 16.6414 10.8507L14.5745 12.9176L12.515 10.8581C12.2223 10.5654 11.7466 10.5659 11.4533 10.8592C11.1599 11.1526 11.1594 11.6282 11.4522 11.921L13.5117 13.9805L11.4455 16.0467C11.1514 16.3408 11.1517 16.8157 11.4444 17.1085C11.7371 17.4012 12.2121 17.4014 12.5062 17.1074L14.5724 15.0412L16.6332 17.102Z"
                fill="#211A1E"
              />
            </svg>
          </div>
          <div :class="`${classVariableName}-gallery-details-modal-body`">
            <div :class="`${classVariableName}-gallery-details-modal-content`">
              <ImageCarousel :images="review.imageList" :currentIndex="currentIndex" resolution="mid"/>
              <div :class="`${classVariableName}-image-review-content`">
                <div :class="`${classVariableName}-review-top`">
                  <div :class="`${classVariableName}-review-top-left`">
                    <ratingComponent
                      :readOnly="true"
                      :allowFraction="true"
                      :initialRating="review.rating"
                      size="s"
                    />
                  </div>

                  <div
                    v-if="
                      !isEmpty(variantMap) &&
                      !isEmpty(variantMap[`${review.alternateCode2}`])
                    "
                    :class="`${classVariableName}-review-top-right`"
                  >
                    <img
                      :class="`${classVariableName}-review-top-variant`"
                      :src="variantMap[`${review.alternateCode2}`].medias[variantMap[`${review.alternateCode2}`].medias.length-1].url"
                    />
                    <div :class="`${classVariableName}-review-top-variant-name`"> {{ variantMap[`${review.alternateCode2}`].color_name || variantMap[`${review.alternateCode2}`].name }} </div>
                  </div>
                </div>

                <div v-if="!isEmpty(review.title)" :class="`${classVariableName}-review-heading-primary`">
                  "{{ review.title }}"
                </div>

                <div
                  v-if="!isEmpty(review.content)"
                  :class="`${classVariableName}-review-heading-secondary`"
                >
                  {{ review.content }}
                </div>
                <div :class="`${classVariableName}-review-bottom-container ${classVariableName}-auto-margin-top`">
                <div :class="`${classVariableName}-review-bottom`">
                  
                  <div :class="`${classVariableName}-review-bottom-user`">
                    <div v-if="!review.anonymous">{{ review.customerName || review.createdBy || "" }}</div>
                    <CertifiedBuyer v-if="review.verified"/>
                    <div v-if="review.verified" :class="`${classVariableName}-review-bottom-verified-tag`">|</div>
                    <div v-if="review.verified" :class="`${classVariableName}-review-bottom-verified-tag`">Verified buyer</div>
                  </div>

                  <fdk-accounts
                    v-slot="accountsData"
                    :class="`${classVariableName}-review-bottom-actions`"
                  >
                    <div
                      v-if="
                        !isEmpty(validationConfig) &&
                        !isEmpty(validationConfig.upvote) &&
                        !validationConfig.upvote.hidden
                      "
                      :class="`${classVariableName}-vote  ${vote ? '' : `${classVariableName}-vote-disabled`}`"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        :class="`${classVariableName}-cursor-pointer`"
                        @click="() => sendVote('UPVOTE', accountsData)"
                      >
                        <rect
                          x="0.5"
                          y="0.5"
                          width="23"
                          height="23"
                          rx="3.5"
                          :fill="selectedAction === 'UPVOTE' ? '#211A1E' : '#F9F9F9'"
                          :stroke="selectedAction === 'UPVOTE' ? '' : '#EEEEEE'"
                        />
                        <g clip-path="url(#clip0_590_34903)">
                          <path
                            d="M10.125 17.625H15.75C16.2687 17.625 16.7125 17.3125 16.9 16.8625L18.7875 12.4562C18.8437 12.3125 18.875 12.1625 18.875 12V10.75C18.875 10.0625 18.6855 10.1252 17.998 10.1252H13.123L14.275 6.64375L14.2937 6.44375C14.2937 6.1875 14.1875 5.95 14.0187 5.78125L13.3562 5.125L9.2375 9.24375C9.0125 9.46875 8.875 9.78125 8.875 10.125V16.375C8.875 17.0625 9.4375 17.625 10.125 17.625ZM9.74805 9.75024L13.3562 6.37524L12 10.75H17.998V12L16.123 16.8752H9.74805V9.75024ZM5.125 10.125H7.625V17.625H5.125V10.125Z"
                            :fill="selectedAction === 'UPVOTE' ? 'white' : 'black'"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_590_34903">
                            <rect
                              x="4.5"
                              y="4.5"
                              width="15"
                              height="15"
                              rx="2"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <span :class="`${classVariableName}-vote-text`">
                        {{ review.upvoteCount }}
                      </span>
                    </div>
                  </fdk-accounts>
                </div>
                <!-- <div v-if="!isEmpty(review.origin)" :class="`${classVariableName}-review-bottom-origin`">
                  From {{ review.origin }}
                </div> -->

                <div :class="`${classVariableName}-review-bottom-details`">
                  <div v-if="!isEmpty(review.origin)" :class="`${classVariableName}-review-bottom-origin`">
                    From {{ review.origin }}
                  </div>
                  <div id="createdAt" :class="`${classVariableName}-review-by`">
                    {{ formatDate(review.createdAt) }}{{ " " }}
                  </div>
                </div>

                </div>
              </div>
            </div>
          </div>
          <div :class="`${classVariableName}-image-review-footer`">
            <div
              v-if="hasPrev"
              :class="`${classVariableName}-image-review-footer-prev`"
              @click="() => getReview(review.index - 1)"
            >
              <LongArrow :direction="'left'" /> &nbsp; Previous
            </div>
            <div
              v-if="hasNext"
              :class="`${classVariableName}-image-review-footer-next`"
              @click="() => getReview(review.index + 1)"
            >
              Next &nbsp; <LongArrow :direction="'right'" />
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { isEmpty, classVariableName, formatDate, emitEvent, getEventData } from "../../utils";
import CUSTOM_EVENTS from "../../constants";
import Modal from "../common/Modal.vue";
import Arrow from "../common/Arrow.vue";
import ratingComponent from "../common/StarRating.vue";
import CertifiedBuyer from "../common/CertifiedBuyer.vue";
import customerServices from "../../services/customer-review";
import LongArrow from "../common/LongArrow.vue";
import ImageCarousel from "../common/ImageCarousel.vue";

export default defineComponent({
  name: "imageReviewModalComponent",
  components: {
    Modal,
    Arrow,
    LongArrow,
    ImageCarousel,
    ratingComponent,
    CertifiedBuyer,
  },
  props: {
    product: Object,
    hasNext: Boolean,
    hasPrev: Boolean,
    currentIndex: Number,
    detailedGalleryFlow: Boolean,
    review: Object,
    validationConfig: Object,
    onClose: Function,
    getReview: Function,
    setAlert: Function,
    openDetailedGallery: Function,
    vote: Boolean
  },
  watch: {
    review(newValue, oldValue) {
      if (newValue.id != oldValue.id) {
        this.selectedAction = null;
      }
    },
  },
  mounted() {
    window.FPI.state.product.variants.subscribe(this.getVariants.bind(this));
  },
  destroy() {
    window.FPI.state.product.variants.unsubscribe(this.getVariants.bind(this));
  },
  setup() {},
  data() {
    return {
      variantMap: null,
      classVariableName: classVariableName,
      selectedAction: null,
    };
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },
    formatDate(val) {
      var date = new Date(val);
      return formatDate(date);
    },
    async getVariants(data) {
      let variants = data.variants;
      if (!isEmpty(variants)) {
        let colorVariants = variants.filter((types) => types.key === "color");
        if (!isEmpty(colorVariants)) {
          this.variantMap = colorVariants[0].items.reduce((vmap, obj) => {
              vmap[obj.uid] = obj;
              return vmap;
            }, {});
        }
      }
    },
    async sendVote(action, accountsData) {
      if (!this.vote || action === this.selectedAction) return;
      emitEvent(CUSTOM_EVENTS.REVIEW_LIKE, getEventData(accountsData.is_logged_in, 'image_gallery', this.product, this.review));
      if (!accountsData.is_logged_in) {
        accountsData.openLogin();
        return;
      }

      let data = {
        contentId: this.review.id,
        vote: action,
      };

      await customerServices
        .voteReview(data)
        .then((data) => {
          let res = data.data;
          if (res.status == 401) {
            accountsData.openLogin();
            return;
          }
          if (action === "DOWNVOTE") {
            this.review.downvoteCount = parseInt(this.review.downvoteCount) + 1;
            if (!isEmpty(this.selectedAction)) {
              this.review.upvoteCount = parseInt(this.review.upvoteCount) - 1;
            }
            this.selectedAction = action;
          } else if (action === "UPVOTE") {
            this.review.upvoteCount = parseInt(this.review.upvoteCount) + 1;
            if (!isEmpty(this.selectedAction)) {
              this.review.downvoteCount =
                parseInt(this.review.downvoteCount) - 1;
            }
            this.selectedAction = action;
          }
        })
        .catch((error) => {
          this.setAlert(error.response.data.info.resultInfo.message, "error");
        });
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../../assets/Review.scss";
</style>
